import { render, staticRenderFns } from "./pageList.vue?vue&type=template&id=0f4fa20a&scoped=true&"
import script from "./pageList.vue?vue&type=script&lang=js&"
export * from "./pageList.vue?vue&type=script&lang=js&"
import style0 from "./pageList.vue?vue&type=style&index=0&id=0f4fa20a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f4fa20a",
  null
  
)

export default component.exports